/**
 * document.exitPointerLock is undefined on iOS.
 * - Tested on iOS Safari 15.6.1.
 */
export function patchExitPointerLock() {
  const { exitPointerLock } = document;
  document.exitPointerLock = () => {
    try {
      exitPointerLock?.call(document);
    } catch {
      // ignore if undefined
    }
  };
}

/**
 * Default 2D canvas contexts to `willReadFrequently: true`.
 *
 * Silences the "Canvas2D: Multiple readback operations using getImageData are
 * faster with the willReadFrequently attribute" warning emitted by libraries
 * we don't control (e.g. vtk.js AnnotatedCubeActor -> ImageHelper.canvasToImageData).
 * Only touches '2d' contexts and never overrides an explicit option. WebGL
 * contexts used for the main rendering are unaffected.
 */
export function patchCanvasWillReadFrequently() {
  const proto = globalThis.HTMLCanvasElement?.prototype;
  if (!proto) return;

  const original = proto.getContext as (
    this: HTMLCanvasElement,
    contextId: string,
    options?: unknown
  ) => RenderingContext | null;

  proto.getContext = function getContext(
    this: HTMLCanvasElement,
    contextId: string,
    options?: unknown
  ) {
    if (contextId === '2d') {
      const opts = (
        options && typeof options === 'object' ? options : {}
      ) as CanvasRenderingContext2DSettings;
      if (opts.willReadFrequently === undefined) {
        return original.call(this, contextId, {
          ...opts,
          willReadFrequently: true,
        });
      }
    }
    return original.call(this, contextId, options);
  } as typeof proto.getContext;
}
